'use client'
import { FC, useState, useRef} from "react";
import { PrismicRichText } from "@prismicio/react";

interface AccessComponentProps {
    internal?: any | null
    retailer?: any | null
    core?: any | null;
    uid?: any | null
}

const AccessComponent: FC<AccessComponentProps> = ({ internal, retailer, core, uid }) => {
    const inputRef = useRef(null) as any
    const [error, setError] = useState(null) as any

    const checkAccess = async () => {
        const password = inputRef.current?.value;
        if (password.length < 8) {
            setError("Password too short.");
            return;
        }

        const paramKey = internal ? "ttfmaps" : "access";
        const res = await fetch(`/api/get-access?${paramKey}=${encodeURIComponent(password)}`);
        const { access } = await res.json();

        if (access) {
            // cookie was set by the GET handler above
            window.location.href = `/${uid}`;   
        } else {
            setError("Password incorrect, please try again.");
        }
        };

return (
        <div className="flex justify-center items-center text-center w-full h-[40dvh] font-fellix">
            <div>
                <h2 className="!font-normal !text-[28px]">Restricted Access</h2>
                {retailer ?
                <article className="prose-a:text-blue prose-a:underline">
                    <PrismicRichText field={core.data.restricted_acccess_text} />
                </article>
                : <p>Please contact the marketing team to gain access</p>}
                {error ? <p className="alert">{error}</p> : <p>&nbsp;</p>}
                <input placeholder="Enter your password" type="password" name="password" className="  rounded-full h-[24px] md:h-[48px] text-center border-[1px] border-solid mt-[20px] bg-white appearance-none" ref={inputRef} />
                <button className="  rounded-full h-[24px] md:h-[48px] text-center border-[1px] border-solid mt-[20px] bg-white px-12 ml-4" onClick={checkAccess} type="button">Submit</button>
            </div>
        </div>
    )
}

export default AccessComponent;